import { ActionType, ProColumns } from '@ant-design/pro-components';
import { DatePicker, Form, message } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import { cloneDeep } from 'lodash';
import { observer } from 'mobx-react';
import { useEffect, useRef, useState } from 'react';
// icons
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable from 'base/ui/components/CustomTable';
import * as Icon from 'base/ui/components/Icons';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { useTranslation } from 'react-i18next';
import { SYSTEM_TITLE } from 'utils/constants';
import { TableReportTHXLKN3M } from '../model';
import { commonPresenter, commonStore, reportWCPresenter, reportWCStore, uiStore } from 'stores/root_store';
import { SearchModel } from 'pages/model';
import { useResizableColumns } from 'utils/reportHelper';
import { formatNumber } from 'utils/formatHelper';
import { CommonModel } from 'services/Main/common_services';
import SaveReportForm from 'pages/Components/reportForm';
import { AiOutlineDownload } from 'react-icons/ai';
import dayjs from 'dayjs';
import { checkPermission, useCheckPermission } from 'utils/permissionHelper';

const { RangePicker } = DatePicker;

const createBCTongHop3Mien = () => {
  return observer(() => {
    useCheckPermission('INDEX');
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = t('page-title.th-xlkn-3mien') + ' - ' + SYSTEM_TITLE;
    const [form] = Form.useForm();

    const [open, setOpen] = useState({
      openDrawer: false,
      openModal: false,
      openConfirm: false,
    });

    const [dataPaging, setDataPaging] = useState<SearchModel>({
      fromTime: undefined,
      toTime: undefined,
    });
    // Dữ liệu table
    const [dataTable, setDataTable] = useState<TableReportTHXLKN3M[]>([]);
    const [isSearch, setIsSearch] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const [disabledPickDate, setDisabledPickDate] = useState(false);
    // data common date
    const [listCommonDate, setListCommonDate] = useState<CommonModel[]>([]);

    const defaultColumn: ProColumns[] = [
      // Khu vực
      {
        title: t('complaint.khu-vuc'),
        dataIndex: 'section',
        key: 'section',
        fixed: 'left',
        // rowScope: 'rowgroup',
        width: 150,
        onCell: (_, index) => {
          if ((index as number) % 4 === 0) {
            return { rowSpan: 4 };
          } else {
            return { rowSpan: 0 };
          }
        },
      },
      //
      {
        title: t('complaint.xlkn'),
        dataIndex: 'type',
        key: 'type',
        fixed: 'left',
        width: 200,
      },
      // Tháng 1
      {
        title: t('complaint.thang-1'),
        dataIndex: 't1',
        key: 't1',
        width: 150,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
      // Tháng 2
      {
        title: t('complaint.thang-2'),
        dataIndex: 't2',
        key: 't2',
        width: 150,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
      // Tháng 3
      {
        title: t('complaint.thang-3'),
        dataIndex: 't3',
        key: 't3',
        width: 150,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
      // Tháng 4
      {
        title: t('complaint.thang-4'),
        dataIndex: 't4',
        key: 't4',
        width: 150,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
      // Tháng 5
      {
        title: t('complaint.thang-5'),
        dataIndex: 't5',
        key: 't5',
        width: 150,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
      // Tháng 6
      {
        title: t('complaint.thang-6'),
        dataIndex: 't6',
        key: 't6',
        width: 150,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
      // Tháng 7
      {
        title: t('complaint.thang-7'),
        dataIndex: 't7',
        key: 't7',
        width: 150,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
      // Tháng 8
      {
        title: t('complaint.thang-8'),
        dataIndex: 't8',
        key: 't8',
        width: 150,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
      // Tháng 9
      {
        title: t('complaint.thang-9'),
        dataIndex: 't9',
        key: 't9',
        width: 150,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
      // Tháng 10
      {
        title: t('complaint.thang-10'),
        dataIndex: 't10',
        key: 't10',
        width: 150,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
      // Tháng 11
      {
        title: t('complaint.thang-11'),
        dataIndex: 't11',
        key: 't11',
        width: 150,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
      // Tháng 12
      {
        title: t('complaint.thang-12'),
        dataIndex: 't12',
        key: 't12',
        width: 150,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
      {
        title: t('complaint.summary'),
        dataIndex: 'total',
        key: 'total',
        width: 150,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
    ];
    const [columns, setColumns] = useState<ProColumns<TableReportTHXLKN3M>[]>(defaultColumn);

    // ======================================================== function =================================================================
    const getDataTable = async (data: any) => {
      await reportWCPresenter.getDataTHXLKN3M(reportWCStore, { ...data, lang: uiStore.language });
      if (reportWCStore.reportTHXLKN3M.isSuccess) {
        const data = cloneDeep(reportWCStore.reportTHXLKN3M.data);
        let dataTemp: TableReportTHXLKN3M[] = [];
        data.forEach((item, index) => {
          dataTemp.push({
            key: `${index * 4 + 1}`,
            type: t('complaint.so-th-xlkn'),
            section: item.section,
            ...item.sthxlkn,
          });
          dataTemp.push({
            key: `${index * 4 + 2}`,
            type: t('complaint.gia-tri-sp'),
            section: item.section,
            ...item.gtsp,
          });
          dataTemp.push({
            key: `${index * 4 + 3}`,
            type: t('complaint.gia-tri-bh'),
            section: item.section,
            ...item.gtbh,
          });
          dataTemp.push({
            key: `${index * 4 + 4}`,
            type: t('complaint.gia-tri-gg'),
            section: item.section,
            ...item.gtgt,
          });
        });
        setDataTable(dataTemp);
        return dataTemp;
      } else {
        message.error(reportWCStore.reportTHXLKN3M.message);
        return [];
      }
    };

    // Lấy danh sách common date
    const getListCommonDate = async () => {
      await commonPresenter.getListSelectCommonDate(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListCommonDate(commonStore.commonRespone.data);
      }
    };

    // Lấy ngày bằng common data
    const getDateByKey = async (key: string) => {
      await commonPresenter.getDateByCommonDate(commonStore, key);
      if (commonStore.commonDate.fromDate) {
        form.setFieldValue('kyBaoCao', [dayjs(commonStore.commonDate.fromDate), dayjs(commonStore.commonDate.toDate)]);
      } else {
        form.setFieldValue('kyBaoCao', undefined);
      }
    };

    useEffect(() => {
      getListCommonDate();
    }, []);

    // show filter form
    const showDrawer = () => {
      setOpen({ ...open, openDrawer: true });
    };
    // close filter form
    const onClose = () => {
      setOpen({ ...open, openDrawer: false });
    };
    // hidden modal (Add)

    // ============================================LƯU MẪU BÁO CÁO =========================================

    const tableRef = useRef<ActionType>();
    const constDataName = 'BCTHXLKN3Mien';
    const {
      isResizablePresent,
      setIsResizablePresent,
      resizableColumnSelect,
      columnsState,
      handleColumnsStateChange,
      templateReportModalRef,
      userReports,
      selectedReportId,
      templateReportModalProps,
      handleResize,
    } = useResizableColumns<TableReportTHXLKN3M>(columns, setColumns, constDataName);

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.th-xlkn-3mien'),
          },
        ]}
        extras={
          <>
            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
              <Icon.Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <CustomProTable<TableReportTHXLKN3M>
            className="[&_.ant-table-thead_th]:!text-center"
            pagination={false}
            rowKey="key"
            bordered
            columns={columns}
            dataSource={dataTable}
            request={async (params = {}, sort, filter) => {
              if (isSearch) {
                const data = await getDataTable(dataPaging);
                return {
                  data: data,
                  success: reportWCStore.reportTHXLKN3M.isSuccess,
                };
              }
              return [];
            }}
            actionRef={tableRef}
            handleResize={handleResize}
            isResizablePresent={isResizablePresent}
            resizableColumnSelect={resizableColumnSelect}
            columnsState={{
              value: Object.keys(columnsState).length > 0 ? columnsState : undefined,
              onChange: (newColumnsState) => {
                handleColumnsStateChange(newColumnsState);
              },
            }}
            toolBarRender={() => [
              <>
                {checkPermission('EXPORT') ? (
                  <CustomButton
                    size="middle"
                    loading={exportLoading}
                    onClick={async () => {
                      setExportLoading(true);
                      await reportWCPresenter.exportExportReportTHXLKN3M({ ...dataPaging, lang: uiStore.language });
                      setExportLoading(false);
                    }}
                    className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
                    type="primary"
                  >
                    <AiOutlineDownload className="block text-base" />
                    <span className="block">{t('btn.export')}</span>
                  </CustomButton>
                ) : (
                  ''
                )}
              </>,
              <SaveReportForm
                setIsResizablePresent={setIsResizablePresent}
                templateReportModalRef={templateReportModalRef}
                userReports={userReports}
                selectedReportId={selectedReportId}
                templateReportModalProps={templateReportModalProps}
              />,
            ]}
          />
        </BoxContainer>

        {/* Form search */}
        <SearchBox
          onClose={onClose}
          open={open.openDrawer}
          className="lg:!w-[25%]"
          footer={
            <CustomButton
              htmlType="submit"
              onClick={() => {
                setIsSearch(true);
                const kyBaoCao = form.getFieldValue('kyBaoCao');

                let fromTime = undefined;
                let toTime = undefined;
                if (kyBaoCao) {
                  fromTime = form.getFieldValue('kyBaoCao')[0].format('YYYY-MM-DD') || undefined;
                  toTime = form.getFieldValue('kyBaoCao')[1].format('YYYY-MM-DD') || undefined;
                }
                setDataPaging({
                  ...form.getFieldsValue(),
                  fromTime: fromTime,
                  toTime: toTime,
                });
                form.submit();
                tableRef.current?.reload();
              }}
              className="my-auto ml-auto"
              type="primary"
            >
              {t('btn.search')}
            </CustomButton>
          }
        >
          <SearchForm form={form}>
            {/* common date */}
            <SearchItem name={'commonKyBC'} label={t('search-form.report-time')} col2>
              <CustomSelect
                options={listCommonDate}
                fieldNames={{ label: 'value', value: 'key' }}
                onChange={async (value, option) => {
                  if (option) {
                    setDisabledPickDate(option.key === 'Custom' ? false : true);
                    await getDateByKey(option.key);
                  } else {
                    setDisabledPickDate(false);
                    form.setFieldValue('kyBaoCao', undefined);
                  }
                }}
                allowClear
              />
            </SearchItem>

            {/* Kỳ báo cáo */}
            <SearchItem name={'kyBaoCao'} label={''} col2>
              <RangePicker disabled={disabledPickDate} format="DD/MM/YYYY" className="w-full" />
            </SearchItem>
          </SearchForm>
        </SearchBox>
      </PageWrapper>
    );
  });
};

export default createBCTongHop3Mien;
